import { useRef, useState } from "react";

const ENTRY_TYPES = [
  { value: "inspectie", label: "Inspectie" },
  { value: "onderhoud", label: "Onderhoud" },
  { value: "beheer", label: "Beheer" },
  { value: "storing", label: "Storing" },
  { value: "test", label: "Test" },
  { value: "wijziging", label: "Wijziging" },
];

export default function LogbookEntryForm({ onSubmit, submitting = false }) {
  const fileInputRef = useRef(null);
  const [entryType, setEntryType] = useState("inspectie");
  const [description, setDescription] = useState("");
  const [attachments, setAttachments] = useState([]);

  function handleFileChange(event) {
    setAttachments(Array.from(event.target.files || []));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    await onSubmit?.({ entryType, description, attachments });
    setDescription("");
    setAttachments([]);
    if (fileInputRef.current) fileInputRef.current.value = "";
  }

  return (
    <form onSubmit={handleSubmit} className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
      <div className="mb-5">
        <h3 className="text-lg font-semibold text-slate-900">Nieuwe logboekregel</h3>
        <p className="mt-1 text-sm text-slate-500">
          Regels zijn immutable. Correcties worden als nieuwe regel toegevoegd.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <label className="block">
          <span className="mb-2 block text-sm font-medium text-slate-700">Type</span>
          <select
            value={entryType}
            onChange={(event) => setEntryType(event.target.value)}
            className="w-full rounded-2xl border border-slate-300 bg-slate-50 px-4 py-3 text-sm outline-none focus:border-emerald-500 focus:bg-white"
          >
            {ENTRY_TYPES.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>

        <label className="block">
          <span className="mb-2 block text-sm font-medium text-slate-700">Bijlagen</span>
          <input
            ref={fileInputRef}
            type="file"
            multiple
            onChange={handleFileChange}
            className="w-full rounded-2xl border border-dashed border-slate-300 bg-slate-50 px-4 py-3 text-sm text-slate-600"
          />
        </label>
      </div>

      <label className="mt-4 block">
        <span className="mb-2 block text-sm font-medium text-slate-700">Beschrijving</span>
        <textarea
          value={description}
          onChange={(event) => setDescription(event.target.value)}
          rows={5}
          required
          className="w-full rounded-2xl border border-slate-300 bg-slate-50 px-4 py-3 text-sm outline-none focus:border-emerald-500 focus:bg-white"
        />
      </label>

      {attachments.length > 0 && (
        <div className="mt-4 rounded-2xl bg-slate-50 p-4 text-sm text-slate-600">
          {attachments.map((file) => (
            <div key={`${file.name}-${file.size}`}>{file.name}</div>
          ))}
        </div>
      )}

      <div className="mt-5 flex justify-end">
        <button
          type="submit"
          disabled={submitting}
          className="rounded-full bg-emerald-600 px-5 py-3 text-sm font-medium text-white transition hover:bg-emerald-700 disabled:opacity-60"
        >
          {submitting ? "Bezig..." : "Logboekregel toevoegen"}
        </button>
      </div>
    </form>
  );
}
